import { ICompany, IPartner } from 'interfaces/companies';
import axios, { Response } from 'services';

export interface ICompaniesResponse {
	items: ICompany[];
	status: string;
};
export const getCompanies = (): Response<ICompaniesResponse> => {
	return axios.get(`/companies`);
};

export interface IUpdateCompanyRequest {
	partners: {
		[key: string]: IPartner;
	}
};
export const updateCompany = (companyId: number, payload: IUpdateCompanyRequest): Response<ICompaniesResponse> => {
	return axios.patch(`/companies/${companyId}`, payload);
};
